"use client";

import { signOutAction } from "@frontend/lib/actions";

export function SignOutButton({ className }: { className?: string }) {
  return (
    <form action={signOutAction} className="w-full">
      <button
        type="submit"
        className={
          className ??
          "inline-flex items-center gap-2 text-sm text-ink-muted transition hover:text-ink"
        }
      >
        <SignOutIcon />
        Sign out
      </button>
    </form>
  );
}

function SignOutIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" className="size-3.5 shrink-0" aria-hidden="true">
      <path
        d="M6 3H4.5A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13H6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M10.5 5.5 13 8l-2.5 2.5M13 8H6.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
